// core
import React from "react";

// components
import LModal from "../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../common/components/Modals/ModalHeader/ModalHeader";
import Icon from "../../../../common/components/Icon/Icon";
import ContentBox from "../../ContentBox/ContentBox";

// styles
import styles from "./PremiumStructuresModal.module.scss";
import cx from "classnames";
import DiagramImage from "../../../assets/stepped-vs-level-diagram.svg";

interface IPremiumStructuresModal {
    isOpen: boolean;
    onClose: () => void;
}

const PremiumStructuresModal: React.FC<IPremiumStructuresModal> = (props) => {
    return (
        <React.Fragment>
            <LModal
                Header={() => (
                    <ModalHeader
                        onClose={props.onClose}
                        title="Here's what you need to know"
                    />
                )}
                calcHeightMode="auto"
                width="wide"
                isOpen={props.isOpen}
                onClose={props.onClose}>
                {() => (
                    <React.Fragment>
                        <p className={cx("text-font-size-ml", styles["premium-hero"])}>
                            Here&apos;s what you need to know: Level cover premiums remain
                            the same, whereas Stepped cover premiums are recalculated
                            annually.
                        </p>

                        <div className={styles["premium-row"]}>
                            <div className={styles["premium-content"]}>
                                <h3 className="text-zero-margin">The big difference</h3>
                                <p className="text-zero-margin">
                                    To put it simply, Stepped premiums, sometimes known as
                                    Rate for Age premiums are recalculated annually and
                                    increase as you get older, but usually start cheaper.
                                    Fixed Premiums or Level Premiums generally start
                                    higher than Stepped Premiums but are considerably
                                    lower in comparison over time.
                                </p>
                            </div>
                            <div
                                className={cx({
                                    [styles["premium-content"]]: true,
                                    [styles["premium-content__graphic"]]: true
                                })}>
                                <img
                                    src={DiagramImage}
                                    id="PremiumStructureGraph"
                                    width="100%"
                                    className={styles["premium-structures-modal--graph"]}
                                />
                            </div>
                        </div>
                        <div
                            className={cx({
                                [styles["premium-row"]]: true,
                                [styles["premium-types"]]: true
                            })}>
                            <ContentBox className={styles["premium-content"]}>
                                <h3
                                    className={cx(
                                        "text-zero-margin",
                                        styles["premium-title"]
                                    )}>
                                    <Icon id="LevelCover" />
                                    &nbsp; Level Cover
                                </h3>
                                <p className="text-zero-margin">
                                    Level cover comes in four length (term) options: 10
                                    years, and until age 65, 70 or 80. If you keep the
                                    policy for longer than the term length, you will
                                    switch to Stepped.
                                </p>

                                <h4 className="text-zero-margin">
                                    Why choose Level cover?
                                </h4>
                                <ul>
                                    <li>Premiums that don&apos;t increase with age</li>
                                    <li>Control over the longer term pricing</li>
                                    <li>Greater control over your budgeting</li>
                                </ul>
                            </ContentBox>

                            <ContentBox className={styles["premium-content"]}>
                                <h3
                                    className={cx(
                                        "text-zero-margin",
                                        styles["premium-title"]
                                    )}>
                                    <Icon id="SteppedCover" className="space-m" />
                                    Stepped Cover
                                </h3>
                                <p className="text-zero-margin">
                                    Stepped cover premiums will rise between 2% - 15% each
                                    year depending on your insurer. This is to cover the
                                    increased risk of you claiming your policy.
                                </p>

                                <h4 className="text-zero-margin">
                                    Why choose Stepped cover?
                                </h4>
                                <ul>
                                    <li>Most common pricing structure</li>
                                    <li>Cheaper upfront cost</li>
                                    <li>More affordable in the short term</li>
                                </ul>
                            </ContentBox>
                        </div>
                    </React.Fragment>
                )}
            </LModal>
        </React.Fragment>
    );
};

export default PremiumStructuresModal;
